import { Button } from "@web/components/ui/button";
import { Textarea } from "@web/components/ui/textarea";
import type { ReaderWorkspace } from "../reader/reader-workspace";

export function BackupPage({ workspace }: { workspace: ReaderWorkspace }) {
  return (
    <section className="space-y-3">
      <div>
        <h1 className="text-lg font-semibold">备份恢复</h1>
        <p className="mt-1 text-sm text-muted-foreground">导出或恢复当前用户阅读数据</p>
      </div>
      <div className="space-y-3 border-y py-3">
        <div className="flex gap-2">
          <Button type="button" size="sm" onClick={() => void workspace.handleExportBackup()} disabled={workspace.busy || !workspace.user}>
            导出
          </Button>
          <Button type="button" size="sm" variant="secondary" onClick={() => void workspace.handleImportBackup()} disabled={workspace.busy || !workspace.backupText.trim()}>
            恢复
          </Button>
        </div>
        <Textarea
          value={workspace.backupText}
          onChange={event => workspace.setBackupText(event.target.value)}
          placeholder="备份 JSON 会显示在这里，也可以粘贴备份后恢复"
          className="min-h-72 text-xs"
        />
      </div>
    </section>
  );
}
